import Component from "../../../lib/component";
import template from './formsBanner.html'
import './formsBanner.scss'
import FormEntrys from "../../../entrys/form";
import AddWfInit from './../../../components/workflow/add-wf/add-wf'
import {CreateFormServer} from "../../../services/formService/CreateFormServer";
import Mediator from '../../../lib/mediator';
import {CalendarTimeService} from "../../../services/calendar/calendar.tool.service";
import {CalendarService} from "../../../services/calendar/calendar.service";

let config = {
	template: template,
	binds: [{
		event: 'click',
		selector: '.tableName',
		callback(event) {
			if(this.data.isSorting || this.data.onCreate){
				return;
			}
			this.actions.changeToForm($(event).data('id'));
		}
		///iframe/addWf/?table_id=1190_WsuRDjEJ9R6vHcHuR8hMzZ&tableName=%E4%B8%AA%E4%BA%BA%E6%97%A5%E6%8A%A5 btnType=new
	}, {
		event: 'click',
		selector: '.submit',
		callback() {
			this.actions.submitForm();
		}
	},{
		event:'click',
		selector:'.sort-wrap',
		callback(){
			this.actions.startSort();
		}
	},{
		event:'click',
		selector:'.left',
		callback(event){
			this.actions.sort($(event).parent(),0);
		}
	},{
		event:'click',
		selector:'.right',
		callback(event){
			this.actions.sort($(event).parent(),this.el.find('.tableName').length);
		}
	},{
		event:'click',
		selector:'.saveSort',
		callback(event){
			this.actions.saveSort();
		}
	}],
	actions: {
		//保存排序
		saveSort(){
			this.el.find('.saveSort').hide();
			this.el.find('.sort-wrap').show();
			this.el.find('.left').css('visibility','hidden');
			this.el.find('.right').css('visibility','hidden');
			this.data.isSorting=false;
			let config={
				data:{

				},
				action:'save',
			};
			$('.tableName').each((index,item)=>{
				config.data[$(item).data('id')]={
					sort:index,
				}
			});
			config.data=JSON.stringify(config.data);
			CalendarService.setAutomaticFill(config);

		},
		//排序
		sort(dom,index){
			let tableNames=this.el.find('.tableName');
			let domIndex=tableNames.index(dom);
			if(domIndex == index){
				return;
			}
			if(index==0){
				dom.parent().get(0).insertBefore(dom.get(0),tableNames.eq(domIndex-1).get(0));
			}else{
				dom.parent().get(0).insertBefore(tableNames.eq(domIndex+1).get(0),dom.get(0));
			}
		},
		//切换排序界面
		startSort(){
			this.el.find('.saveSort').show();
			this.el.find('.sort-wrap').hide();
			this.el.find('.left').css('visibility','visible');
			this.el.find('.right').css('visibility','visible');
			this.data.isSorting=true;
		},
		//切换当前显示表单
		changeToForm(id) {
			this.el.find(`.form-wrap[data-id=${this.data.currentTableId}]`).hide();
			this.el.find(`.tableName[data-id=${this.data.currentTableId}]`).removeClass('current');
			if (this.el.find(`.form-wrap[data-id=${id}]`).length) {
				this.el.find(`.form-wrap[data-id=${id}]`).show();
			} else {
				this.actions.createForm(id);
			}
            let _this=this;
            Mediator.on('form:create'+id, () => {
                _this.data.onCreate=false;
                _this && _this.actions && _this.actions.setTimeValue && _this.actions.setTimeValue(id);
            })
			Mediator.removeAll('form:create'+this.data.currentTableId);
			this.data.currentTableId = id;
			this.el.find(`.tableName[data-id=${this.data.currentTableId}]`).addClass('current');
			this.actions.setTimeValue(id);
		},
		//加载表单或工作流
		createForm(id) {
			this.data.onCreate=true;
			let $formWrap = $(`<div class="form-wrap" data-id=${id}></div>`);
			this.el.find('content').append($formWrap);
			for (let tb of this.data.tableNames) {
				if (tb.tableId == id) {
					if (tb.isFromWorkflow) {
						let obj = {
							table_id: id,
							tableName: tb.tableName,
							btnType: 'new'
						}
						this.data.workFlows[id]=new AddWfInit({data: {obj}});
						this.data.workFlows[id].render($formWrap)
						this.data.workFlows[id].el.find('.workflow-flex').hide();
						this.data.workFlows[id].el.find('#miniFormBtn').remove();
					} else {
						FormEntrys.initForm({
							table_id: id,
							form_id: '',
							is_view: 0,
							flow_id: this.data.flowId || '',
							el: $formWrap,
							btnType: 'none',
						})
					}
				}
			}
		},
		//提交表单
		submitForm() {
			if(this.data.workFlows[this.data.currentTableId]){
				this.data.workFlows[this.data.currentTableId].data.addWf.actions.submitAddWorkflow();
				return;
			}
			let currentForm = CreateFormServer.childForm[this.data.currentTableId];
			if (currentForm.data.isBtnClick) {
				return;
			}
			currentForm.data.isBtnClick = true;
			currentForm.actions.onSubmit();
		},
		//自动填充表单设计的日期字段
		setTimeValue(id) {
			let currentForm = CreateFormServer.childForm[id];
			let currentObj;
			for (let obj of this.data.tableNames) {
				if (obj.tableId == id) {
					currentObj = obj;
					break;
				}
			}
			if(!currentForm){
				return;
			}
			for (let dfield in currentForm.data.data) {
				console.log('所选日期');
				console.log(this.data.selectDate);
				if (currentObj.fields && currentObj.fields.length && ~currentObj.fields.indexOf(currentForm.data.data[dfield].id)) {
					if(this.data.selectDate){
						currentForm.actions.setFormValue(dfield,this.data.selectDate);
					}else{
						currentForm.actions.setFormValue(dfield,CalendarTimeService.getDayDate());
					}
				}
			}
		}
	},
	data: {
		// calendarFormsOptions: [{
		// 	tableId: '5613_CHEUbzmZMsjDFT3AiwPB46',
		// }, {
		// 	tableId: '9339_ycfatDsud3R2zihrHhcAfb',
		// }],
		// tableNames: [
		// 	{
		// 		tableName: '表2',
		// 		tableId: '5613_CHEUbzmZMsjDFT3AiwPB46',
		// 		dfields: ['5093_hWHDF37u2M5HD4n5hdMy8L'],
		// 	},
		// 	{
		// 		tableName: '表1',
		// 		tableId: '9339_ycfatDsud3R2zihrHhcAfb'
		// 	}, {
		// 		tableName: '表3',
		// 		tableId: '1190_WsuRDjEJ9R6vHcHuR8hMzZ',
		// 		isFromWorkflow: 'true'
		// 	}
		// ],
		currentTableId: '',
		workFlows:{},
		isSorting:false,
        onCreate:false,
        isWorkReport:false,
	},
	afterRender() {
		let id = this.data.currentTableId = this.data.tableNames[0].tableId
		if(this.data.isWorkReport) {
			this.el.find('.tabBtn').hide();
		}
		this.actions.createForm(id);
		this.el.find('.tableName').eq(0).addClass('current');
        let _this=this;
        Mediator.on('form:create'+this.data.currentTableId, () => {
        	_this.data.onCreate=false;
            _this && _this.actions && _this.actions.setTimeValue && _this.actions.setTimeValue(this.el.find('.current').data('id'));
        })
		//监听表单提交成功关闭窗口
		Mediator.on('calendar-save-success',()=>{
                $(calendarOpenForms.el).erdsDialog('destroy')
                Mediator.removeAll('form:create'+_this.data.currentTableId);
                Mediator.removeAll('calendar-save-success');
                _this._destroy();
		});
	},
	beforeDestory(){
        Mediator.removeAll('calendar-save-success');
        Mediator.removeAll('form:create'+this.data.currentTableId);
	}
}
let FormsBanner = Component.extend(config);

let calendarOpenForms = {
	el: null,
	show: function (config = {}) {
		let w, h;
		if (window.innerWidth < 1300) {
			w = 800;
			h = 600;
		}
		this.el = $("<div class='forms-banner'>").appendTo('body');
		let formsBanner = new FormsBanner(config);
		formsBanner.render(this.el);
		this.el.erdsDialog({
			width: w || 1400,
			height: h || 800,
			modal: true,
			maxable: true,
			defaultMax: false,
			title: '新建',
			close: function () {
				$(this).erdsDialog('destroy');
				Mediator.removeAll('form:create'+formsBanner.data.currentTableId);
				Mediator.removeAll('calendar-save-success');
				formsBanner._destroy();
				// formsBanner.destroySelf();
			}
		})
	},
}

export {calendarOpenForms}


// WEBPACK FOOTER //
// app/components/calendar/calendarOpenForms/calendarOpenForms.js